export default __webpack_public_path__ + "static/rei-ca0bbf346df7fbd96151bab3ca79910f.png";